module.exports = __webpack_public_path__ + "static/media/collection.45f0f950.png";